export const openChatInNewTab = (userId) => {
    const chatUrl = `https://yourdomain.com/chat/${userId}`;
    window.open(chatUrl, '_blank');
};